/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const CartRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: SkeletonSettings.BORDER}}
        {...props}>

        {/* Thumbnail image */}
        <rect x="0" y={`calc(50% - 40px)`} width="80" height="80"/>

        {/* Product details */}
        <rect x="90" y={`calc(50% - 40px)`} rx="3" ry="3" width="30%" height="10"/>
        <rect x="90" y={`calc(50% - 16px)`} rx="3" ry="3" width="28%" height="10"/>
        <rect x="90" y={`calc(50% + 4px)`} rx="3" ry="3" width="26%" height="10"/>
        <rect x="90" y={`calc(50% + 30px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* Packaging info */}
        <rect x="45%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Weight price */}
        <rect x="54%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Unit price */}
        <rect x="63%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Quantity selector */}
        <rect x={`calc(77% - 25px)`} y={`calc(50% - 1.5px)`} width="1%" height="3"/>
        <rect x={`calc(78% - 20px)`} y={`calc(50% - 20px)`} width="40" height="40"/>
        <rect x={`calc(78% + 25px)`} y={`calc(50% - 1.5px)`} width="1%" height="3"/>

        {/* Total price */}
        <rect x="85%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Remove from cart button */}
        <circle cx={`calc(100% - 15px)`} cy="50%" r="15"/>

    </ContentLoader>
);
